import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import {
  AnimationSettingsModel,
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { useContext, useEffect, useState } from 'react';
import { BiX } from 'react-icons/bi';
import Message from '../../../utils/Message/Message';
import {
  CheckBoxComponent,
  SwitchComponent,
} from '@syncfusion/ej2-react-buttons';
import './style.css';
import { ThemeContext } from '../../../context/theme.context';
import { all_information, loadingShow } from '../../../App';
import { BsCheck2 } from 'react-icons/bs';
import {
  AddShiftWorkbenchSubStuff,
  DeleteShiftWorkbenchSubStuff,
  EditShiftWorkbenchSubStuff,
  getShiftWorkbenchSubStuff,
} from '../../../services/ShiftWorkbench/ShiftWorkbenchSubStuff';
import WorkOrders from '../../CloudPlaner/WorkOrders';

const toolbarOptions = [
  {
    text: 'Add',
    tooltipText: 'Add',
    prefixIcon: 'e-add',
    id: 'add',
  },
  'Edit',
  'Delete',
  'Update',
  'Cancel',
  {
    text: 'Refresh',
    tooltipText: 'Refresh',
    prefixIcon: 'e-refresh',
    id: 'refresh',
  },
  'ColumnChooser',
  'ExcelExport',
  'Search',
];
const FilterOptions: FilterSettingsModel = { type: 'Menu' };
const animationSettings: AnimationSettingsModel = {
  effect: 'Zoom',
  duration: 400,
  delay: 0,
};
const pageOptions: PageSettingsModel = {
  currentPage: 1,
  pageSize: 20,
  pageCount: 10,
};
const editOptions: EditSettingsModel = {
  allowEditing: true,
  allowAdding: false,
  allowDeleting: true,
  newRowPosition: 'Top',
};
let switchService: SwitchComponent = new SwitchComponent({});
let switchWeather: SwitchComponent = new SwitchComponent({});
let switchIsComplete: SwitchComponent = new SwitchComponent({});
let switchBreakDown: SwitchComponent = new SwitchComponent({});
let gridmaintenenceWorkOrder: GridComponent = new GridComponent({});
let gridMaintenenceOperation: GridComponent = new GridComponent({});
let breakdown = false;
let service = false;
let weather = false;
let isComplete = 0;
let created_date = new Date();
let workbench_id = -1;
let isRenderBegin = false;
const unit: string = 'maintanceop';
const MaintenenceOperations = ({ workbench_data }: { workbench_data: any }) => {
  const [hideDialogOrder, setHideDialogOrder] = useState(false);
  const [dataOrder, setDataOrder] = useState<Array<any>>([]);
  const [dataDaily, setDataDaily] = useState<Array<any>>([]);

  const buttonsOrder: ButtonPropsModel[] = [
    {
      click: () => {
        setHideDialogOrder(false);
      },
      buttonModel: {
        content: 'Done',
      },
    },
    {
      click: () => {
        if (gridmaintenenceWorkOrder.getSelectedRecords().length > 0) {
          SaveListOrder(gridmaintenenceWorkOrder.getSelectedRecords());
        } else {
          Message.error('no records selected for Work Order');
        }
      },
      buttonModel: {
        content: 'Save',
      },
    },
  ];

  const context = useContext(ThemeContext);
  const getWorkbenchDaily = async (query: string) => {
    await getShiftWorkbenchSubStuff(query).then((res) => {
      if (isRenderBegin) {
        setDataDaily(res.data);
      }
    });
  };
  const openDialogOrder = () => {
    setHideDialogOrder(true);
  };
  const closeDialogOrder = () => {
    setHideDialogOrder(false);
  };
  useEffect(() => {
    isRenderBegin = true;
    workbench_id = parseInt(workbench_data.id);
    created_date = new Date(workbench_data.date);
    getWorkbenchDaily(`${unit}$${workbench_id}`);
    return () => {
      if (gridMaintenenceOperation) {
        gridMaintenenceOperation.destroy();
      }
      isRenderBegin = false;
    };
  }, []);
  const toolbarClick = async (args: any) => {
    if (args.item.id === 'add') {
      isComplete = 0;
      service = false;
      breakdown = false;
      weather = false;
      setHideDialogOrder(true);
    }
    if (args.item.id === 'refresh') {
      if (workbench_id === -1) {
        Message.error('Please create a workbench first!');
        return false;
      } else {
        getWorkbenchDaily(`${unit}$${workbench_id}`);
      }
    }
    if (
      gridMaintenenceOperation &&
      args.item.id === 'shiftworkbenchMaintence_excelexport'
    ) {
      gridMaintenenceOperation.excelExport();
    }
  };
  const SaveListOrder = async (data: any) => {
    let SWorkbenchDailyShiftInfoBulkDtos: any = [];
    var date = created_date;
    await data.map((item: any) => {
      const obj = {
        app: 'app',
        organization_id: all_information.company_id?.toString(),
        description: item.description,
        workbench_id: workbench_id,
        date: new Date(date),
        order_id: item.order_id,
        asset_code: item.asset_code,
        shift: '',
        team: '',
        priority: item.priority_code,
        type: item.typeCode,
        section: item.order_section_code,
        est_hours: -1,
        trade: '',
        number_of_trades: -1,
        duration: '',
        rapaired_by: '',
        malfunctuion_start_date: '',
        expected_resolution: new Date(),
        actual_resolution: new Date(),
        downtime: '',
        SMU: -1,
        breakdown: breakdown,
        service: service,
        weather: weather,
        isEmergency: true,
        shift_comments: '',
        complete: 0,
        user_id: all_information.user_id,
        unit,
      };
      SWorkbenchDailyShiftInfoBulkDtos.push(obj);
    });
    AddShiftWorkbenchSubStuff(SWorkbenchDailyShiftInfoBulkDtos)
      .then((res: any) => {
        loadingShow(false);
        Message.success('Success');
        getWorkbenchDaily(`${unit}$${workbench_id}`);
        setHideDialogOrder(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const isBreakdownTemplate = (args: any) => {
    let isBreakDown = args.breakdown;
    return (
      <div>
        {isBreakDown ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  };
  const isBreakDownTemplateEditing = (args: any) => {
    return (
      <SwitchComponent
        checked={args.breakdown}
        ref={(scope: SwitchComponent) => (switchBreakDown = scope)}
      />
    );
  };
  const isServiceTemplate = (args: any) => {
    let isService = args.service;
    return (
      <div>
        {isService ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  };
  const isWeatherTemplate = (args: any) => {
    let isWeather = args.weather;
    return (
      <div>
        {isWeather ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  };
  const isServicetemplateEditing = (args: any) => {
    return (
      <SwitchComponent
        checked={args.service}
        ref={(scope: SwitchComponent) => (switchService = scope)}
      />
    );
  };
  const isWeathertemplateEditing = (args: any) => {
    return (
      <SwitchComponent
        checked={args.weather}
        ref={(scope: SwitchComponent) => (switchWeather = scope)}
      />
    );
  };
  const isEmergencyTemplate = (args: any) => {
    let isEmergency = args.isEmergency;
    return (
      <div>
        {isEmergency ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  };
  const isEmergencyTemplateEditin = (args: any) => {
    return <BsCheck2 size={20} color='green' />;
  };
  const isCompleteTemplate = (args: any) => {
    let isComplete = args.complete;
    return (
      <div>
        {isComplete ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  };
  const isCompletetemplateEditing = (args: any) => {
    return (
      <SwitchComponent
        checked={args.complete}
        ref={(scope: SwitchComponent) => (switchIsComplete = scope)}
      />
    );
  };
  const actionBeginDaily = (args: any) => {
    if (args.action === 'edit') {
      SaveListOrderEdit(args.data);
    } else if (args.requestType === 'delete') {
      savePointDeleteDaily(args.data);
    }
  };
  const SaveListOrderEdit = (data: any) => {
    let service = switchService.checked;
    let weather = switchWeather.checked;
    let breakdown = switchBreakDown.checked;
    let complete = switchIsComplete.checked;
    const obj = {
      ...data,
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      date: new Date(created_date),
      number_of_trades: data.number_of_trades,
      malfunctuion_start_date: data.malfunctuion_start_date.trim(),
      expected_resolution: data.expected_resolution,
      actual_resolution: data.actual_resolution,
      SMU: data.SMU,
      breakdown: breakdown,
      service: service,
      weather: weather,
      complete: complete,
      user_id: all_information.user_id,
      unit,
    };
    EditShiftWorkbenchSubStuff(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        getWorkbenchDaily(`${unit}$${workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const savePointDeleteDaily = (obje: any) => {
    const obj = JSON.stringify({
      id: obje[0].id,
    });
    DeleteShiftWorkbenchSubStuff(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        getWorkbenchDaily(`${unit}$${workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  return (
    <div className='shiftworkbench-maintenenceldldfldll'>
      <GridComponent
        ref={(g: GridComponent) => (gridMaintenenceOperation = g)}
        height={'calc(-200px + 60vh)'}
        dataSource={dataDaily}
        width={window.innerWidth - 115}
        filterSettings={FilterOptions}
        editSettings={editOptions}
        showColumnChooser
        allowExcelExport
        allowFiltering={true}
        allowPaging={true}
        pageSettings={pageOptions}
        showColumnMenu={true}
        allowResizing={true}
        allowGrouping={true}
        // created={OncreatedDaildy.bind(this)}
        toolbar={toolbarOptions}
        toolbarClick={toolbarClick.bind(this)}
        actionBegin={actionBeginDaily.bind(this)}
        gridLines='Both'
      >
        <ColumnsDirective>
          <ColumnDirective
            field='order_id'
            headerText='Order ID'
            textAlign='Left'
            width='100'
            isPrimaryKey
            visible={false}
          />
          <ColumnDirective
            field='asset_code'
            headerText='Asset'
            textAlign='Left'
            isPrimaryKey
          />
          <ColumnDirective
            field='description'
            headerText='Description'
            textAlign='Left'
            isPrimaryKey
          />
          <ColumnDirective
            field='shift'
            headerText='Shift'
            textAlign='Left'
            isPrimaryKey
          />
          <ColumnDirective
            field='team'
            isPrimaryKey
            headerText='Team'
            textAlign='Left'
          />
          <ColumnDirective
            field='priority'
            headerText='Priority'
            textAlign='Left'
            isPrimaryKey
          />
          <ColumnDirective
            field='type'
            isPrimaryKey
            headerText='Type'
            textAlign='Left'
          />
          <ColumnDirective
            field='section'
            headerText='Section'
            textAlign='Left'
            isPrimaryKey
          />
          <ColumnDirective
            field='trade'
            headerText='Trade'
            textAlign='Left'
            isPrimaryKey
          />
          <ColumnDirective
            field='est_hours'
            headerText='Est Hours'
            textAlign='Left'
            isPrimaryKey
          />
          <ColumnDirective
            field='number_of_trades'
            headerText='of Trades'
            textAlign='Left'
            isPrimaryKey
          />
          <ColumnDirective
            field='duration'
            headerText='Duration'
            textAlign='Left'
            isPrimaryKey
          />
          <ColumnDirective
            field='rapaired_by'
            headerText='Rapaired By'
            textAlign='Left'
          />
          <ColumnDirective
            field='malfunctuion_start_date'
            headerText='Mallfunction Start Date'
            textAlign='Left'
          />
          <ColumnDirective
            field='expected_resolution'
            headerText='Expected Resolution'
            textAlign='Left'
            editType='datetimepickeredit'
          />
          <ColumnDirective
            field='actual_resolution'
            headerText='Actual Resolution'
            textAlign='Left'
            editType='datetimepickeredit'
          />
          <ColumnDirective field='SMU' headerText='SMU' textAlign='Left' />
          <ColumnDirective
            field='downtime'
            headerText='Downtime'
            textAlign='Left'
          />
          <ColumnDirective
            field='breakdown'
            headerText='Breakdown'
            textAlign='Left'
            template={isBreakdownTemplate.bind(this)}
            editTemplate={isBreakDownTemplateEditing.bind(this)}
          />
          <ColumnDirective
            field='service'
            headerText='Service'
            textAlign='Left'
            template={isServiceTemplate.bind(this)}
            editTemplate={isServicetemplateEditing.bind(this)}
          />
          <ColumnDirective
            field='weather'
            headerText='Weather'
            textAlign='Left'
            template={isWeatherTemplate.bind(this)}
            editTemplate={isWeathertemplateEditing.bind(this)}
          />
          <ColumnDirective
            field='isEmergency'
            headerText='Emergency'
            textAlign='Left'
            isPrimaryKey
            template={isEmergencyTemplate.bind(this)}
            editTemplate={isEmergencyTemplateEditin.bind(this)}
          />
          <ColumnDirective
            field='shift_comments'
            headerText='Shift Comments'
            textAlign='Left'
          />
          <ColumnDirective
            field='complete'
            headerText='Complete'
            textAlign='Left'
            template={isCompleteTemplate.bind(this)}
            editTemplate={isCompletetemplateEditing.bind(this)}
          />
        </ColumnsDirective>
        <Inject
          services={[
            Edit,
            Toolbar,
            Filter,
            Page,
            ColumnChooser,
            ExcelExport,
            ColumnMenu,
            Resize,
            Group,
          ]}
        />
      </GridComponent>
      <DialogComponent
        isModal={true}
        id='defaultdialogMaintenenceOrder'
        showCloseIcon={true}
        animationSettings={animationSettings}
        visible={hideDialogOrder}
        header='Work Orders'
        buttons={buttonsOrder}
        open={openDialogOrder.bind(this)}
        close={closeDialogOrder.bind(this)}
        width={window.innerWidth - 150}
      >
        <div className='row'>
          <div className='top-field'>
            <div className='order-top-fields'>
              <label>Breakdown</label>
              <CheckBoxComponent
                checked={breakdown}
                onChange={(x: any) => {
                  breakdown = x.target.checked;
                }}
              />
            </div>
            <div className='order-top-fields'>
              <label>Service</label>
              <CheckBoxComponent
                checked={service}
                onChange={(x: any) => {
                  service = x.target.checked;
                }}
              />
            </div>
            <div className='order-top-fields'>
              <label>Weather</label>
              <CheckBoxComponent
                checked={weather}
                onChange={(x: any) => {
                  weather = x.target.checked;
                }}
              />
            </div>
          </div>
          {hideDialogOrder ? (
            <WorkOrders
              noNeedFilterPanel
              multiSelection
              gridRef={(g: GridComponent) => (gridmaintenenceWorkOrder = g)}
              needDidMount={true}
            />
          ) : null}
        </div>
      </DialogComponent>
    </div>
  );
};
export default MaintenenceOperations;
